import { getAllowBackOrder } from './get-allow-back-order.js';
import { getDisplayType } from './get-display-type.js';
import { getLineItemAvailability } from './get-line-item-availability.js';
import { getLineItemDiscount } from './get-line-item-discount.js';
import { getLineItemName } from './get-line-item-name.js';
import { getLineItemPrice } from './get-line-item-price.js';

const getSharedProps = (lineItemRaw, product, intl)=>{
    const variant = product.masterData.current.variant;
    return {
        allowBackOrder: getAllowBackOrder(variant),
        displayType: getDisplayType(lineItemRaw, intl),
        availability: getLineItemAvailability(variant.availability || null),
        currency: intl.currency,
        discount: getLineItemDiscount(lineItemRaw.price, intl.locale, lineItemRaw.discounts || null),
        id: lineItemRaw.id,
        imageAlt: getLineItemName(product, intl.locale),
        isGift: lineItemRaw.isGift,
        name: getLineItemName(product, intl.locale),
        price: getLineItemPrice(lineItemRaw.price, intl.locale),
        productType: product.productType,
        quantity: lineItemRaw.quantity
    };
};

export { getSharedProps };
//# sourceMappingURL=shared-line-item-data-mapper.js.map
